import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LandingPage.css";

const Index = () => {
  const tableData = JSON.parse(sessionStorage.getItem("urlParams"));
  // console.log('tableData', tableData)
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (!tableData) {
      setError("Something went wrong. Please scan the QR code again");
    }
  }, []);

  return (
    <div className="startWrap">
      <span className="error-validation p-4 mb-4">{error}</span>
      <div className="start-menu-wrapper">
        <img src="/images/logo-white.png" alt="EZmenu" className="logo-icon" />
        <div className="button-wrap">
          {/* <a
						href={`""`}
						onClick={ev => {
							ev.preventDefault();
							navigate('/home/menu')
						}}
					>
						<div className="btn-menu">
							<img src="/images/food-and-drink.svg" alt='food-and-drink' className="menu-icon" />
							<span className="btn-text">View Menu</span>
						</div>
					</a> */}
          <a
            href={`""`}
            onClick={(ev) => {
              ev.preventDefault();
              navigate(
                `/ezmenu/${tableData.tableNumer}/${tableData.rvc}/${tableData.zone}`,
              );
            }}
          >
            <div className="btn-menu">
              <img
                src="/images/food-and-drink.svg"
                alt="food-and-drink"
                className="menu-icon"
              />
              <span className="btn-text">View Menu</span>
            </div>
          </a>
          {/* <a
						href={`""`}
						onClick={ev => {
							ev.preventDefault();
							window.open('/view-document/WaterSports')
						}}
					>
						<div className="btn-menu">
							<img src="/images/food-and-drink.svg" alt='food-and-drink' className="menu-icon" />
							<span className="btn-text">Water Sports</span>
						</div>
					</a> */}
          <a
            href={`""`}
            onClick={(ev) => {
              ev.preventDefault();
              navigate(`/call-waiter`);
            }}
          >
            <div className="btn-menu">
              <img
                src="/images/restaurant-waiter.svg"
                alt="restaurant-waiter"
                className="menu-icon"
              />
              <span className="btn-text">Call Waiter</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Index;
